import { IDotsButtonProps } from "dots-ui/dotsButton";
import { useContext } from "react";
import { AvisContext } from "../../context";
import { AvisConfirmButton } from "./AvisConfirmButton";

export function AvisSaveButton(props: Readonly<IDotsButtonProps>) {
  const { label, ...restProps } = props;
  const { res } = useContext(AvisContext);

  return (
    <AvisConfirmButton label={label ?? res("button_Save")} {...restProps} />
  );
}
